import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import TagEditor from 'component_ui/tag-editor';

function TagFilter() {
    this.defaultAttrs({
        filterName: null,
    });

    this.after('initialize', function() {
        TagEditor.attachTo(this.$node, {
            dataSource: this.$node.data('tag-data-source-url'),
            allowCreateTag: false,
            submitOnTagChange: false,
        });

        this.on('uiSuggestionsSelected', this.tagSelected);
        this.on('uiTagDeleted', this.tagUnselected);
        this.on(document, 'dataFilterChange', this.filtersChanged);
    });

    this.tagSelected = function(e, data) {
        this.trigger('uiTagFilterSelected', {
            tagName: data.tagName,
            filterName: this.attr.filterName,
        });
    };

    this.tagUnselected = function(e, data) {
        this.trigger('uiTagFilterDeleted', {
            tagName: data.tagName,
            filterName: this.attr.filterName,
        });
    };

    this.filtersChanged = function(e, data) {
        const updatedTags = data.filters[this.attr.filterName] || [];
        this.trigger('uiReplaceTags', { tags: updatedTags });
    };
}

export default defineComponent(TagFilter);



// WEBPACK FOOTER //
// ./src/js/component_ui/tag-filter.js